import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Accordion } from './Accordion';
const bonosData = [{
  id: 'bono-1',
  title: 'Guía de Supervivencia de Laboratorio',
  icon: '🧪',
  description: 'Todo lo que necesitás saber antes de pisar un laboratorio por primera vez.',
  purpose: 'Para evitar errores comunes, conocer el material y entender las normas de bioseguridad básicas.'
}, {
  id: 'bono-2',
  title: 'Plantillas de Informes de TP',
  icon: '📝',
  description: 'Estructuras pre-armadas para que tus informes de trabajos prácticos queden perfectos.',
  purpose: 'Para ahorrar horas de formato y asegurar que no te falte ninguna sección importante que los docentes evalúan.'
}, {
  id: 'bono-3',
  title: 'Flashcards de Vías Metabólicas',
  icon: '⚡',
  description: 'Tarjetas de repaso rápido con las enzimas y sustratos clave de cada vía.',
  purpose: 'Para repasar en el colectivo o antes de entrar a rendir, asegurando que la memoria a corto plazo esté fresca.'
}, {
  id: 'bono-4',
  title: 'Directorio de Recursos Digitales',
  icon: '🌐',
  description: 'Los mejores simuladores, bases de datos y canales de YouTube para estudiantes de Bioquímica.',
  purpose: 'Para tener a mano herramientas interactivas cuando los libros no alcanzan para entender un tema complejo.'
}];
export function Bonos() {
  const accordionItems = bonosData.map((bono, index) => ({
    id: bono.id,
    title: <div className="flex flex-col gap-1" data-id="element-25">
        <div className="flex items-center gap-2 text-white font-bold" data-id="element-26">
          <span className="text-[#254EA5]" data-id="element-27">
            BONO 0{index + 1} — {bono.icon}
          </span>
          <span className="flex-1" data-id="element-28">{bono.title}</span>
        </div>
        <div className="flex items-center gap-2 text-sm" data-id="element-29">
          <span className="line-through text-[#1A5E51]" data-id="element-30">$8.000</span>
          <span className="bg-brand-dark text-brand-tealLight text-xs font-bold px-2 py-0.5 rounded" data-id="element-31">
            GRATIS
          </span>
        </div>
      </div>,
    content: <div className="pt-2 text-white" data-id="element-32">
        <p className="font-medium mb-3" data-id="element-33">{bono.description}</p>
        <div className="bg-brand-dark/30 border border-brand-dark/20 p-3 rounded-lg text-sm" data-id="element-34">
          <span className="font-bold text-brand-tealLight" data-id="element-35">
            Para qué sirve:
          </span>{' '}
          {bono.purpose}
        </div>
      </div>
  }));
  return <section className="bg-brand-darker py-16 px-4 sm:px-6 lg:px-8" data-id="element-36">
      <div className="max-w-2xl mx-auto" data-id="element-37">
        {/* Oferta 1 - 4 Bonos */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-teal rounded-3xl p-6 sm:p-8 mb-12 shadow-xl" data-id="element-38">
          <div className="text-center mb-8" data-id="element-39">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-40">
              4 bonos incluidos. Gratis. Siempre.
            </h2>
            <p className="text-white/80 font-medium text-lg" data-id="element-41">
              Valor total:{' '}
              <span className="line-through text-white/60" data-id="element-42">$32.000 ARS</span>{' '}
              <span className="text-brand-dark font-bold bg-white/20 px-2 py-0.5 rounded" data-id="element-43">
                → $0
              </span>{' '}
              con tu sistema.
            </p>
          </div>

          <Accordion items={accordionItems} className="mb-4" itemClassName="bg-white/10 border-white/20" headerClassName="hover:bg-white/20" contentClassName="border-white/20" data-id="element-44" />
        </motion.div>

        {/* Oferta 2 - Bonos Adicionales */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-dark border-2 border-brand-teal rounded-3xl p-6 sm:p-8 relative overflow-hidden" data-id="element-45">
          <div className="absolute top-0 right-0 bg-brand-teal/10 w-40 h-40 rounded-full blur-3xl -mr-10 -mt-10 pointer-events-none" data-id="element-46" />

          <div className="text-center mb-8 relative z-10" data-id="element-47">
            <span className="inline-flex items-center gap-1.5 bg-brand-teal text-white text-xs font-bold px-3 py-1 rounded-full mb-4" data-id="element-48">
              ⭐ Exclusivo de la Oferta Completa
            </span>
            <h2 className="text-2xl font-bold text-white mb-3" data-id="element-49">
              Sumá 3 herramientas más a tu BioKit.
            </h2>
            <p className="text-gray-300 text-sm" data-id="element-50">
              Herramientas avanzadas para quienes buscan la máxima eficiencia en
              su estudio.
            </p>
          </div>

          <div className="space-y-4 relative z-10" data-id="element-51">
            {[{
            id: 'bono-5',
            title: 'BONO 05 — Masterclass: Cómo leer papers científicos',
            desc: 'Guía en video para extraer la información clave de publicaciones en inglés sin perder horas.'
          }, {
            id: 'bono-6',
            title: 'BONO 06 — Plantillas de CV y Carta de Presentación',
            desc: 'Formatos profesionales optimizados para buscar pasantías o tu primer trabajo en laboratorio.'
          }, {
            id: 'bono-7',
            title: 'BONO 07 — Casos Clínicos Integradores',
            desc: 'Dossier con 20 casos reales resueltos para practicar el razonamiento diagnóstico.'
          }].map(bono => <div key={bono.id} className="bg-white/5 border border-white/10 rounded-xl p-4" data-id="element-52">
                <h3 className="text-brand-tealLight font-bold mb-1" data-id="element-53">
                  {bono.title}
                </h3>
                <p className="text-gray-300 text-sm" data-id="element-54">{bono.desc}</p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}